import { render, staticRenderFns } from "./cardDetailForNonMaintenance.vue?vue&type=template&id=50bf7729&scoped=true"
import script from "./cardDetailForNonMaintenance.vue?vue&type=script&lang=js"
export * from "./cardDetailForNonMaintenance.vue?vue&type=script&lang=js"
import style0 from "./cardDetailForNonMaintenance.vue?vue&type=style&index=0&id=50bf7729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf7729",
  null
  
)

export default component.exports